/**
*
* SideBar
*
*/

import SideBar from './SideBar.jsx'
import './SideBar.less'

export default SideBar